<mf-global-spinner />
<mf-header />
<mf-side-menu />
<router-outlet />
<app-notification-area />
